import { WarehouseElementData } from "components/WarehouseElements/WarehouseElementsData";
import { INVALID_INDEX } from "constants/globals";
import { Serializable } from "./Serializable";
import { Shortcut } from "components/WarehouseElements/WarehouseHeaders/WarehouseSearchZone/Shortcuts/Shortcuts";

export type PlanDimension = {
  start: {
    x: number;
    y: number;
  };
  end: {
    x: number;
    y: number;
  };
};

export class WarehouseInfos implements Serializable<WarehouseInfos> {
  storeNb = INVALID_INDEX;
  plan: PlanData | null = null;

  deserialize(input: any): WarehouseInfos {
    this.storeNb = input.magNum;
    this.plan = new PlanData().deserialize(input.plan);
    return this;
  }
}
export class PlanData implements Serializable<PlanData> {
  dimensions: PlanDimension | undefined;
  elements: WarehouseElementData[] = [];
  shortcuts: Shortcut[] = [];

  deserialize(input: any): PlanData {
    if (!input) return this;

    const { dimension, elements = [], raccourcis = [] } = input;

    this.dimensions = dimension ? dimension : undefined;

    this.elements = elements.map((e: any) =>
      new WarehouseElementData().deserialize(e)
    );

    this.shortcuts = raccourcis.map((e: any) => new Shortcut().deserialize(e));

    return this;
  }
}
